/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import menuTypes from 'constants/menuTypes';
import { useTranslate } from 'hooks/useTranslate';

import Page from 'modules/_shared/components/Pages/Page';
import Button from 'modules/_shared/components/Buttons';
import TableLoader from 'modules/_shared/components/Tables/TableLoader';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';
import CustomDataTable from 'modules/_shared/components/Tables/CustomDataTable';
import { useGetMenu } from 'modules/administratives/hooks/useGetMenu';
import { resetStateSociety } from 'modules/_shared/redux/resetActions';

import tableColumns from '../../utils/administratedListTableColumns';
import { useAdministratedList } from '../../hooks/useAdministratedList';

function AdministratedList({ items = 10 }) {
  const { t, i18n } = useTranslate();
  const dispatch = useDispatch();

  const { data: tableData, isLoading } = useAdministratedList();

  const [currentTableColumns, setCurrentTableColumns] = useState(
    tableColumns(i18n)
  );

  const pageDescription = useMemo(
    () =>
      tableData?.length > 0
        ? t('AdministratedHaveSocieties', {
            count: tableData?.length,
          })
        : t('AdministratedNoSocieties'),
    [tableData?.length, t]
  );

  useEffect(() => {
    setCurrentTableColumns(tableColumns(i18n));
  }, [i18n.language]);

  useGetMenu(menuTypes.MAIN);

  useEffect(() => {
    dispatch(resetStateSociety());
  }, []);

  return (
    <Page id="administrated-list">
      <PageListHeader
        subTitle={t('AdministratedTitle')}
        description={pageDescription}
        actions={[
          <Link to="/diagrama-administradas">
            <Button variant="outline-light" icon="network" text={t('Chart')} />
          </Link>,
          <Link to="/cuadro-administradas">
            <Button
              variant="outline-light"
              icon="menu-squared"
              text={t('View')}
            />
          </Link>,
        ]}
      />

      {tableData.length > 0 && (
        <CustomDataTable
          data={tableData}
          columns={currentTableColumns}
          searchBy={t('Society')}
          pagination
          className="nk-tb-list"
          rowsPerPage={items}
          actions
          showDense
        />
      )}

      {isLoading && <TableLoader rows={items} />}
    </Page>
  );
}

export default AdministratedList;
